<template>
    <div class="webtab-widget-content">
        <div v-if="!webTab" class="loading-state">
            <a-spin size="small" />
            <span>Yükleniyor...</span>
        </div>
        <div v-else-if="!iframeUrl" class="error-state">
            <span class="material-icons">error_outline</span>
            <span>Widget URL'si oluşturulamadı</span>
        </div>
        <iframe
            v-else
            :src="iframeUrl"
            class="webtab-iframe"
            frameborder="0"
            allow="camera; microphone; geolocation; fullscreen; autoplay; clipboard-read; clipboard-write"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-modals allow-downloads allow-top-navigation"
        />
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "WebTabWidgetContent",
    props: {
        webTab: {
            type: Object,
            default: null,
        },
        contact: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        ...mapGetters({
            getWebTabUrl: "webtabs/getWebTabUrl",
        }),
        iframeUrl() {
            if (!this.webTab) return null;
            return this.getWebTabUrl(this.webTab, this.contact);
        },
    },
};
</script>

<style lang="scss" scoped>
.webtab-widget-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .loading-state,
    .error-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        gap: 12px;
        color: #8796af;

        .material-icons {
            font-size: 32px;
        }
    }

    .error-state {
        color: #ff4d4f;
    }

    .webtab-iframe {
        width: 100%;
        height: 100%;
        border: none;
        flex: 1;
    }
}
</style>

